import React, { useState, useEffect, useContext } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridItem from "app/components/Grid/GridItem.js";
import GridContainer from "app/components/Grid/GridContainer.js";
import Button from "app/components/CustomButtons/Button.js";
import Card from "app/components/Card/Card.js";
import CardHeader from "app/components/Card/CardHeader.js";
import CardBody from "app/components/Card/CardBody.js";
import CardFooter from "app/components/Card/CardFooter.js";
import axios from 'axios';
import { Redirect, useLocation } from 'react-router';
import TextField from '@mui/material/TextField';
import ShipperAddress from "app/components/Address/Shipperaddress.js";
import ConsigneeAddress from "app/components/Address/Consigneeaddress.js";
import Typography from '@mui/material/Typography';
import AddAddress from "app/components/Address/addaddress.js";
import Autocomplete from '@mui/material/Autocomplete';
import ShipperAddressAlternative from "app/components/Address/ShipperaddressNotAccountHolder.js";
import PackagesForm from "app/components/ShipmentPackages/PackagesFormDQuote.js";
import Box from '@mui/material/Box';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { DatePicker } from '@mui/lab';
import { darkBlueColor } from 'app/layout/material-dashboard-react';
import LaunchRoundedIcon from '@mui/icons-material/LaunchRounded';
import SeaQuoteSummary from "app/components/Summary/SeaQuoteSummary.js";
import AirQuoteSummary from "app/components/Summary/AirQuoteSummary.js";
import CircularProgress from '@mui/material/CircularProgress';
import WarningIcon from '@mui/icons-material/Warning';
import CustomerAddress from "app/components/Address/CustomerAddress.js";
import { useHistory } from "react-router-dom";
import { Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText } from '@material-ui/core';
import { LoginStatusContext } from 'app/context/LoginStatusContext';

const styles = {
    cardCategoryWhite: {
        color: "rgba(255,255,255,.62)",
        margin: "0",
        fontSize: "14px",
        marginTop: "0",
        marginBottom: "0",
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
    },
};

const useStyles = makeStyles(styles);

//Format date string
function ProcessDate(date) {
    var shortDate = CreateShortDate(date);
    var requiredGBDate = shortDate.toLocaleDateString('en-GB');
    return requiredGBDate;
}

function CreateShortDate(date) {
    var shortDate = date.substring(0, date.indexOf('T'));
    var [YYYY, MM, DD] = shortDate.split('-');
    return new Date(YYYY, MM - 1, DD);
}

export default function ShipmentEdit() {
    const classes = useStyles();

    const [termType, setTermType] = useState([]);
    const [cargoMode, setCargoMode] = useState([]);
    const [terminal, setTerminal] = useState([]);
    const [showPackages, setshowPackages] = useState(false);
    const [shipmentID, setShipmentID] = useState(0);
    const [postTypeShipmentQuote, setPostTypeShipmentQuote] = useState('update');
    const [shipmentRef, setShipmentRef] = useState('');
    const [userAdded, setUserAdded] = useState('');
    const [dateAdded, setDateAdded] = useState();
    const [quoteButtonValue, setQuoteButtonValue] = useState('NEXT');
    const [showDeleteButton, setShowDeleteButton] = useState(false);
    const [showPortShipper, setShowPortShipper] = useState(false);
    const [showPortDelivery, setShowPortDelivery] = useState(false);
    const [terminalDestinationID, setTerminalDestinationID] = useState([]);
    const [terminalSourceID, setTerminalSourceID] = useState([]);
    const [selectedCargoMode, setSelectedCargoMode] = useState([]);
    const [quoteDetails, setQuoteDetails] = useState();
    const [quotePackages, setQuotePackages] = useState([]);
    const [collectionDate, setCollectionDate] = useState(new Date());
    const [expectedDeliveryDate, setExpectedDeliveryDate] = useState(null);
    const [showShipperAlternative, setShowShipperAlternative] = useState(false);
    const [showAcceptButton, setShowAcceptButton] = useState(false);
    const [acceptedQuote, setAcceptedQuote] = useState(false);
    const [addressShipperID, setAddressShipperID] = useState('');
    const [addressShipperColID, setAddressShipperColID] = useState('');
    const [addressConsigneeID, setAddressConsigneeID] = useState('');
    const [addressConsigneeDelID, setAddressConsigneeDelID] = useState('');
    const [hasTotalCost, setHasTotalCost] = useState(false);
    const [quoteAttachments, setQuoteAttachments] = useState([]);
    const [bookingType, setBookingType] = useState();
    const [primaryTransportMode, setPrimaryTransportMode] = useState();
    const [pendingQuote, setPendingQuote] = useState(false);
    const [isTerminated, setIsTerminated] = useState(false);
    const [showInsuranceFinancialValue, setShowInsuranceFinancialValue] = useState(false);
    const [insuranceFinancialValue, setInsuranceFinancialValue] = useState('');
    const [showDeleteDialog, setShowDeleteDialog] = useState(false);

    const location = useLocation();
    const history = useHistory();
    const params = new URLSearchParams(location.search);

    const { setIsLoggedIn } = useContext(LoginStatusContext);
    
    useEffect(() => {
        async function validateUserSessionId() {
            try {
                await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/api/login/ValidateUserSessionId`,)
                        .then(() => setIsLoggedIn(true));
                
            } catch (error) {
                setIsLoggedIn(false);
                window.location.replace(`${process.env.PUBLIC_URL}/login`);
            }
        }
        validateUserSessionId();
    }, [setIsLoggedIn]);

    useEffect(() => {
        handleTerminal();
        handleCargoModes();
        handleTermTypes();

        //On load populate the quote details
        const handleQuoteDetails = () => {
            axios
                .get(`${process.env.REACT_APP_API_ENDPOINT}/api/shipment/GetShipmentByID`, { params: { shipmentID: params.get("shipmentId") } })
                .then((res) => {
                    console.log(JSON.stringify(res.data));
                            //TODO set up with API to get IP address of user to determine if user is in China or the US, and set the locale setting appropriately.
                            setShipmentID(res.data.shipmentID);
                            setShipmentRef(res.data.shipmentRef);
                            setUserAdded(res.data.userAdded);
                            setDateAdded(res.data.dateAdded);
                            setBookingType(res.data.bookingTypeID);
                            setPrimaryTransportMode(res.data.primaryTransportMode);
                            setSelectedCargoMode({ id: res.data.cargoMode });
                            setInsuranceFinancialValue(res.data.financialValue);
                            //Collection date
                            setCollectionDate(res.data.collectionDateTimeWindowStart);
                            let date = res.data.collectionDateTimeWindowStart;
                            if (date != null) {
                                let requiredGBDate = ProcessDate(date);
                                res.data.collectionDateTimeWindowStart = requiredGBDate;
                            }

                            //Valid To Date
                            date = res.data.shipmentQuote.validToDate;
                            if (date != null) {
                                let requiredGBDate = ProcessDate(date);
                                res.data.shipmentQuote.validToDate = requiredGBDate;
                            }

                            //Delivery Date
                            if (res.data.expectedDeliveryDateTimeWindowStart !== null) {
                                setExpectedDeliveryDate(res.data.expectedDeliveryDateTimeWindowStart);
                                date = res.data.expectedDeliveryDateTimeWindowStart;
                                if (date != null) {
                                    let requiredGBDate = ProcessDate(date);
                                    res.data.expectedDeliveryDateTimeWindowStart = requiredGBDate
                                }
                            }

                            //Accept button
                            if (res.data.shipmentQuote.totalCharge > 0  && !res.data.webPortalAssociatedShipment) {
                                setShowAcceptButton(true);
                                setShowDeleteButton(false);
                                setHasTotalCost(true);
                            }
                            //Delete button
                            if (res.data.shipmentQuote.totalCharge > 0 && res.data.attachments.some(q => q.documentTypeID === 26)) {
                                setShowDeleteButton(true);
                            }

                            //Address/Terminal IDs
                            if (res.data.addresses.length > 0) {
                                for (let i = 0; i < res.data.addresses.length; i++) {

                                    if (res.data.addresses[i].addressUseCode === 'SHP') {
                                        setAddressShipperID(res.data.addresses[i].addressID);
                                    }
                                    if (res.data.addresses[i].addressUseCode === 'COL') {
                                        setAddressShipperColID(res.data.addresses[i].addressID);
                                    }
                                    if (res.data.addresses[i].addressUseCode === 'CNE') {
                                        setAddressConsigneeID(res.data.addresses[i].addressID);
                                    }
                                    if (res.data.addresses[i].addressUseCode === 'DEL') {
                                        setAddressConsigneeDelID(res.data.addresses[i].addressID);
                                    }
                                }
                            }

                            if (res.data.shipmentQuote.isTerminated) {
                                setIsTerminated(true);
                                setShowAcceptButton(false);
                                setShowDeleteButton(false);
                            }
                    setQuoteAttachments(res.data.attachments);
                    setQuoteDetails(res.data);
                })
                .catch((e) => {
                    console.error(`An error occured whilst attempting to retrieve and set quote data. Error details: ${e}`);
                });
        };

        //On load populate the quote packages
        const handleQuotePackages = () => {
            axios
                .get(`${process.env.REACT_APP_API_ENDPOINT}/api/shipment/GetShipmentPackagesByID`, { params: { shipmentID: params.get("shipmentId") } })
                .then((res) => {
                    setQuotePackages(res.data);
                })
                .catch((e) => {
                    console.log('error happened');
                });
        };

        handleQuoteDetails();
        handleQuotePackages();
    }, []);

    const onCollectionDateChange = (date) => {
        setCollectionDate(date);
    };

    const getDefaultTermType = (termTypeCode) => {
        handlePortPathway(null, { label: termTypeCode });
        return termTypeCode;
    };



    //On change handle the Term Types request
    const handleTermTypes = () => {
        axios
            .get(`${process.env.REACT_APP_API_ENDPOINT}/api/lookup/GetTermTypes`)
            .then((res) => {
                setTermType(res.data);
            })
            .catch((e) => {
                console.log('error happened');
            });
    };

    //On change handle the termtype selected
    const handlePortPathway = (event, value) => {
        if (value.label.includes("CIF")) {
            setShowPortShipper(false);
            setShowPortDelivery(true);
            setShowShipperAlternative(false);
            setShowInsuranceFinancialValue(true);
        }
        else if (value.label.includes("CFR")) {
            setShowPortShipper(false);
            setShowPortDelivery(true);
            setShowShipperAlternative(false);
            setShowInsuranceFinancialValue(false);
            setInsuranceFinancialValue('');
        }
        else if (value.label.includes("DAP") || value.label.includes("DDP")) {
            setShowPortShipper(false);
            setShowPortDelivery(false);
            setShowShipperAlternative(false);
            setShowInsuranceFinancialValue(false);
            setInsuranceFinancialValue('');
        }
        else if (value.label.includes("FCA") || value.label.includes("FOB")) {
            setShowPortShipper(true);
            setShowPortDelivery(false);
            setShowShipperAlternative(false);
            setShowInsuranceFinancialValue(false);
            setInsuranceFinancialValue('');
        }
        else if (value.label.includes("EXW")) {
            setShowPortShipper(false);
            setShowPortDelivery(false);
            setShowShipperAlternative(true);
            setShowInsuranceFinancialValue(false);
            setInsuranceFinancialValue('');
        }
        else {
            setShowPortShipper(false);
            setShowPortDelivery(false);
            setShowShipperAlternative(false);
            setShowInsuranceFinancialValue(false);
            setInsuranceFinancialValue('');
        }
    }

    //On change handle the Terminal request
    const handleTerminal = (event, searchText) => {
        if (searchText) {
            axios
                .get(`${process.env.REACT_APP_API_ENDPOINT}/api/lookup/GetTerminals`, { params: { PrimaryTransportMode: primaryTransportMode, SearchText: searchText } })
                .then((res) => {
                    setTerminal(res.data);
                })
                .catch((e) => {
                    console.log("getTerminals api call did not complete");
                });
        }
        else {
            setTerminal([]);
        }
    };


    //On change obtain the terminalID selected
    const handleSourceTerminalID = (event, value) => {
        if (value) {
            setTerminalSourceID(value.id);
            setPostTypeShipmentQuote('delete');
        }
    }

    //On change obtain the terminalID selected
    const handleDestinationTerminalID = (event, value) => {
        if (value) {
            setTerminalDestinationID(value.id);
            setPostTypeShipmentQuote('delete');
        }
    }
    //On change handle the Cargo Modes request
    const handleCargoModes = (event, value) => {

        setSelectedCargoMode(value);

        axios
            .get(`${process.env.REACT_APP_API_ENDPOINT}/api/lookup/GetCargoModes`)
            .then((res) => {
                setCargoMode(res.data);
            })
            .catch((e) => {
                console.log('error happened');
            });
    };

    const assignDefaultCargo = (defaultCargo) => {
        let newCargoMode = [...cargoMode].filter((c) => {
            return c.id === defaultCargo;
        });
        if (newCargoMode.length > 0) {
            setSelectedCargoMode(newCargoMode[0]);
            return newCargoMode[0].id;
        }
        return '';
    };

    const getDefaultStackMultiplier = (stackMultiplier) => {
        if (stackMultiplier === 2) {
            return "Yes";
        }

        return "No";
    };

    const terminateQuote = () => {
        axios.patch(`${process.env.REACT_APP_API_ENDPOINT}/api/shipmentquote/terminate/${shipmentID}`)
            .then(setIsTerminated(true))
            .catch((error) => console.error(`An error occured whilst trying to terminate quote with the error: ${error}`));
    }

    const createFormData = (e) => {
        e.preventDefault();

        const form = e.currentTarget;

        const formData = new FormData(form);
        formData.append("postType", postTypeShipmentQuote);
        formData.append("dateAdded", dateAdded);
        formData.append("userAdded", userAdded);
        formData.append("shipmentID", shipmentID);
        formData.append("shipmentRef", shipmentRef);
        formData.append("homeCostCentreId", sessionStorage.getItem('_HomeCostCentreId'));

        if (collectionDate) {
            formData.append("collectionDate", collectionDate.toLocaleString());
        }
        formData.append("bookingTypeID", bookingType);
        formData.append("primaryTransportMode", primaryTransportMode);

        if (expectedDeliveryDate !== null) {
            formData.append("deliveryDate", expectedDeliveryDate.toLocaleString());
        }

        let cargoMode = formData.get('cargoMode');
        if (!cargoMode) {
            cargoMode = quoteDetails[0].cargoMode;
            formData.append("cargoMode", cargoMode);
            assignDefaultCargo(cargoMode);
        }

        let termType = formData.get('termtype');
        if (!termType) {
            termType = quoteDetails[0].termTypeCode;
            formData.append("termtype", termType);
        }

        if (termType.includes("CFR") || termType.includes("CIF")) {
            formData.append("sourceTerminalID", 0);
            formData.append("deliveryTerminalID", terminalDestinationID)
            setShowPortDelivery(true);
        }
        else if (termType.includes("DAP") || termType.includes("DDP") || termType.includes("EXW")) {
            formData.append("sourceTerminalID", 0);
            formData.append("deliveryTerminalID", 0)
        }
        else if (termType.includes("FCA") || termType.includes("FOB")) {
            formData.append("sourceTerminalID", terminalSourceID);
            formData.append("deliveryTerminalID", 0)
        }
        else {
            formData.append("sourceTerminalID", 0);
            formData.append("deliveryTerminalID", 0)
        }

        let plainFormData = Object.fromEntries(formData.entries());

        if (postTypeShipmentQuote !== 'delete') {
            let deleteSet = 'delete';

            if (typeof plainFormData.shipperAddressID !== 'undefined') {
                if (plainFormData.shipperAddressID !== addressShipperID.toString()) {
                    formData.append("postType", deleteSet);
                    setPostTypeShipmentQuote("delete");
                    plainFormData = Object.fromEntries(formData.entries());
                    return formData;
                }
            }
            if (typeof plainFormData.consigneeAddressID !== 'undefined') {
                if (plainFormData.consigneeAddressID !== addressConsigneeID.toString()) {
                    formData.append("postType", deleteSet);
                    setPostTypeShipmentQuote("delete");
                    plainFormData = Object.fromEntries(formData.entries());
                    return formData;
                }
            }
            if (typeof plainFormData.collectionAddressID !== 'undefined') {
                if (plainFormData.collectionAddressID !== '0') {
                    if (plainFormData.collectionAddressID !== addressShipperColID.toString()) {
                        formData.append("postType", deleteSet);
                        setPostTypeShipmentQuote("delete");
                        plainFormData = Object.fromEntries(formData.entries());
                        return formData;
                    }
                }
            }
            if (typeof plainFormData.deliveryAddressID !== 'undefined') {
                if (plainFormData.deliveryAddressID !== '0') {
                    if (plainFormData.deliveryAddressID !== addressConsigneeDelID.toString()) {
                        formData.append("postType", deleteSet);
                        setPostTypeShipmentQuote("delete");
                        plainFormData = Object.fromEntries(formData.entries());
                        return formData
                    }
                }
            }
        }

        return formData
    }

    const submitQuote = (e) => {
        setPendingQuote(true);
        const plainFormData = Object.fromEntries(createFormData(e).entries());
        const formDataJsonString = JSON.stringify(plainFormData);

        axios
            .post(
                `${process.env.REACT_APP_API_ENDPOINT}/api/shipmentquote`,
                formDataJsonString
            )
            .then(function (response) {
                if (response != null) {
                    if (response.status === 200) {
                        var variableInResponse = response.data.split(",");
                        if (variableInResponse.length > 4) {
                            setShipmentID(variableInResponse[0]);
                            setShipmentRef(variableInResponse[1]);
                            setUserAdded(variableInResponse[2]);
                            setDateAdded(variableInResponse[3]);
                            if (variableInResponse[4] === '3') {
                                window.location.replace("/LeoSeaPortal/searchquote");
                            }
                            setshowPackages(true);
                            setQuoteButtonValue('Save Edit')
                            setShowDeleteButton(true);
                        }
                    }
                    if (postTypeShipmentQuote === "delete") {
                        window.location.replace("/LeoSeaPortal/searchquote");
                    }
                    setPostTypeShipmentQuote('update');
                }
                setPendingQuote(false);
            })
            .catch(function (error) {
                setPendingQuote(false);
                console.log(error);
            });

    }

    const toggleAcceptedQuote = () => {
        setAcceptedQuote(true);
    }

    const convertQuoteToShipment = () => {
        const shipmentToQuoteReq =
        {
            primaryTransportMode: primaryTransportMode,
            shipmentID: shipmentID,
            shipmentRef: shipmentRef
        };

        axios.post(`${process.env.REACT_APP_API_ENDPOINT}/api/shipmentquote/ConvertQuoteToShipment`, shipmentToQuoteReq)
            .then((res) => {
                if (res.status === 201) {
                    window.location.replace(`/LeoSeaPortal/bookingdetails?shipmentId=${res.data.shipmentId}`);
                }
            })
            .catch((error) => console.error(`An error occured whilst trying to convert a quote to a shipment with the error: ${error}`));
    };

    const documentOnClick = (document) => {
        if (document !== null) {
            if (document.stream) {
                openDocument(document);
            }
            else {
                axios
                    .get(`${process.env.REACT_APP_API_ENDPOINT}/api/attachment/GetAttachmentStream`, { params: { fileName: document.filename, location: document.location } })
                    .then((res) => {
                        if (res.data.length !== 0) {
                            document.stream = res.data;
                            openDocument(document);
                        }
                    })
                    .catch((e) => {
                        console.log('Attachment API error happened');
                    });
            }
        }
    }

    function openDocument(document) {
        const binaryString = window.atob(document.stream);
        const bytes = new Uint8Array(binaryString.length);
        const mappedData = bytes.map((byte, i) => binaryString.charCodeAt(i));
        const blob = new Blob([mappedData], { type: document.mediaType });
        const fileUrl = URL.createObjectURL(blob);
        window.open(fileUrl);
    }

    const insuranceFinancialValueOnChange = (event) => {
        if (event.target.value) {
            setInsuranceFinancialValue(event.target.value)
        }
    }

    //Handle the on submit request to post the shipment 
    const onSubmit = (e) => {
        if (acceptedQuote === true) {
            convertQuoteToShipment(e);
        }
        else {
            submitQuote(e);
        }
    };

    const handleDeleteDialogClose = () => setShowDeleteDialog(false);
    const handleDeleteDialogOpen = () => setShowDeleteDialog(true);

    return (
        <div style={{ position: 'relative', zIndex: '0' }}>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <Box sx={{ p: 2, display: 'flex' }}>
                            <Card>
                                <CardHeader style={{ backgroundColor: '#2059A7' }}>
                                <h4 className={classes.cardTitleWhite}>{isTerminated && <><WarningIcon /><i>(Terminated) </i></>}Quote Details Summary</h4>
                                </CardHeader>
                                <CardBody>
                                    {bookingType === 19 && (<AirQuoteSummary quoteDetails={quoteDetails}> </AirQuoteSummary>)}
                                    {bookingType === 20 && (<SeaQuoteSummary quoteDetails={quoteDetails}> </SeaQuoteSummary>)}
                                    <Accordion style={{ marginTop: "40px" }} defaultExpanded={true}>
                                        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header" style={{ backgroundColor: darkBlueColor, color: "#fff" }}>
                                            <Typography>Quote Packages</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <table className='table table-striped' id="ShipmentSearch" aria-labelledby="tabelLabel">
                                                <thead>
                                                    <tr>
                                                        <th>Quantity</th>
                                                        <th>Type</th>
                                                        <th>Description</th>
                                                        <th>Total Gross Weight</th>
                                                        <th>Length</th>
                                                        <th>Width</th>
                                                        <th>Height</th>
                                                        <th>Volume</th>
                                                        <th>Stackable</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {quotePackages.map((item, i) =>
                                                        <tr key={`${item.packageID} - ${i}`}>
                                                            <td>{item.packageCount}</td>
                                                            <td>{item.packageTypeDescription}</td>
                                                            <td>{item.description}</td>
                                                            <td>{item.grossWeight}{"\n"}{item.measureUnitsGrossWeight}</td>
                                                            <td>{item.length}{"\n"}{item.measureUnitsLength}</td>
                                                            <td>{item.width}{"\n"}{item.measureUnitsWidth}</td>
                                                            <td>{item.height}{"\n"}{item.measureUnitsHeight}</td>
                                                            <td>{item.volume}{"\n"}{item.measureUnitsVolume}</td>
                                                            <td>{getDefaultStackMultiplier(item.stackMultiplier)}</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </AccordionDetails>
                                    </Accordion>
                                    <Accordion style={{ marginTop: "40px" }} defaultExpanded={true}>
                                        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header" style={{ backgroundColor: darkBlueColor, color: "#fff" }}>
                                            <Typography>Documents</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <table className='table table-striped' id="ShipmentSearch" aria-labelledby="tabelLabel">
                                                <thead >
                                                    <tr>
                                                        <th>Document Type</th>
                                                        <th>Date Added</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {quoteAttachments.map((item, i) =>
                                                        <tr key={`${item.attachmentID} - ${i}`}>
                                                            <td>{item.documentTypeDescription}</td>
                                                            <td>{new Date(item.dateAdded).toLocaleString()}</td>
                                                            <td align="right">
                                                                <a onClick={() => documentOnClick(item)}>
                                                                    <LaunchRoundedIcon style={{ cursor: 'pointer'}}></LaunchRoundedIcon>
                                                                </a>
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </AccordionDetails>
                                    </Accordion>
                                    <GridItem>
                                        <br/>
                                        <p><em>* Currency exchange rates are calculated on the date of quotation and are subject to change.</em></p>
                                </GridItem>
                            </CardBody>
                            {!isTerminated &&
                                <CardFooter>
                                    {showAcceptButton && <Button color="purple" type="button" onClick={() => convertQuoteToShipment()}>Accept</Button>}
                                    {showDeleteButton &&
                                        <div>
                                            <Button color="purple" type="button" onClick={handleDeleteDialogOpen}>Decline</Button>
                                            <Dialog
                                                open={showDeleteDialog}
                                                onClose={handleDeleteDialogClose}
                                                aria-labelledby="alert-dialog-title"
                                                aria-describedby="alert-dialog-description"
                                            >
                                                <DialogTitle id="alert-dialog-title">Quote Termination</DialogTitle>
                                                <DialogContent>
                                                    <DialogContentText color='dark' id="alert-dialog-description">
                                                        This will terminate the quote. This can not be undone. Are you sure?
                                                    </DialogContentText>
                                                </DialogContent>
                                                <DialogActions>
                                                    <Button color="purple" onClick={terminateQuote}>Yes</Button>
                                                    <Button color="purple" onClick={handleDeleteDialogClose}>No</Button>
                                                </DialogActions>
                                            </Dialog>
                                        </div>
                                    }
                                </CardFooter>
                            }
                            </Card>
                        </Box>
                    </GridItem>
            </GridContainer>
        </div>
    );
}